import AxiosInstance from '../config/AxiosInstance';

/** 1 = contains, 2 = may contain (traces). Mirrors the API's AllergenLevel. */
export const ALLERGEN_LEVEL = {
    CONTAINS: 1,
    MAY_CONTAIN: 2,
} as const;

export type AllergenLevel =
    (typeof ALLERGEN_LEVEL)[keyof typeof ALLERGEN_LEVEL];

export interface Allergen {
    id: string;
    code: string;
    name: string;
    companyId: string | null;
    icon: string | null;
    isActive: boolean;
}

/** One assignment on a product, as sent in the product payload. */
export interface ProductAllergen {
    allergenId: string;
    level: AllergenLevel;
}

/**
 * The allergens a company can assign — the 14 global standard allergens (plus
 * any company rows in a later phase). Small fixed list, so no pagination.
 */
const getListAllergens = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/allergens/list');
        return { data };
    } catch (error) {
        throw error;
    }
};

export { getListAllergens };
